import React from "react";
import { IconButton, Tooltip } from "@mui/material";
import { Download } from "@mui/icons-material";
import styled from 'styled-components';
import DatePicker from 'react-datepicker';
export const styles = {
    container: {
        height: '100%',
        marginTop: 50,
        width: '100%',
        alignItems: 'center',
        justifyContent: 'center',
    },
    title: {
        marginLeft: 10,
        fontWeight: 'bold',
    },
    divider: {
        borderBottomWidth: 1,
        height: 5,
    },
    sectionContainer: {
        marginTop: 15,
        width: '98%',
        alignItems: 'center',
        marginLeft: 10,
    },
    card: {
        backgroundColor: "#EEF2F7",
        padding: "0.8rem",
    },
    cardHeader: {
        backgroundColor: "#F8F8F9",
        fontWeight: "700",
        borderTopRightRadius: "5px",
        borderTopLeftRadius: "5px",
    },

    cardTitle: {
        fontSize: "16px",
        fontWeight: "600",
        lineHeight: "16px",
        color: "#0160F1",
    },
    cardContent: {
        backgroundColor: "#FFFFFF",
        borderBottomRightRadius: "5px",
        borderBottomLeftRadius: "5px",
        fontSize: 15,
        // paddingTop: 5,
    },
    label: {
        fontSize: 15,
    },


    locationCodeCardHeader: {
        backgroundColor: "#F8F8F9",
        fontWeight: "700",
        borderTopRightRadius: "5px",
        borderTopLeftRadius: "5px",
    },
    locationCardContent: {
        backgroundColor: "#FFFFFF",
        borderBottomRightRadius: "5px",
        borderBottomLeftRadius: "5px",
        fontSize: 15,
    },

    fullWidth: {
        width: "100%"
    },


    whiteBackgrnd: {
        backgroundColor: "white"
    },
    redColor: {
        color: "red"
    },
    saveDataButton: {
        alignItems: "center",
        justifyContent: "center",
    },
    downloadAssetMasterButton: {
        marginTop: 2,
        marginBottom: 1,
        marginLeft: 70
    },
    dateGrid: {
        display: "flex",
        alignItems: "center",
        gap: "1rem"
    },
    downloadBttnStyle: {
        display: "flex",
        justifyContent: 'flex-start',
        marginLeft: '6rem'
    },
    downloadSupplyerBttn: {
        justifyContent: 'flex-start',
        alignItems: 'center',
        marginLeft: 3
        // marginTop: 3
    },
    fileUploadBox: {
        // border: "1px solid lightgrey",
        borderRadius: "5px",
    },
    borderRadiusfive: {
        border: "1px solid lightgrey",
        borderRadius: "5px",
    },
    tableContainer: {
        height: 700,
        width: '100%'
    },
    tableCellStyle: {
        fontWeight: 'bold',
        textAlign: 'center'
    },
    teableContentCenter: {
        textAlign: 'center'
    },
    buttonStyles: {
        base: {
            padding: "10px 20px",
            fontWeight: "bold",
            color: "#fff",
            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
        },
        approve: {
            backgroundColor: "#4CAF50",
        },
        reject: {
            backgroundColor: "#f44336",
            marginLeft: 25
        },
        cancel: {
            backgroundColor: "#f44336",
            color: "#fff",
        },
    },
    loaderOverlay: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        zIndex: 10
    },
    paper: {
        marginBottom: '20px',
        paddingTop: 10,
        paddingBottom: 10,
        borderWidth: 2,
    },
    stepStyle: {
        fontWeight: 'bold',
        // color: '#FF5733',
    },
    sectionTitle: {
        marginLeft: 10,
        fontWeight: 'bold',
    },
    gridContainer: {
        width: '100%',
        paddingLeft: 10,
        paddingRight: 10,
    },
    inputBox: {
        border: '1px solid lightgrey',
        borderRadius: '5px',
        padding: 10,
    },
    approvePaymentContainer: {
        backgroundColor: "#EEF2F7",
        justifyContent: 'center',
        alignItems: 'center',

    },

    approvePaymentCard: {
        backgroundColor: "#EEF2F7",
        padding: { xs: "1rem", md: "1.3rem" },
    },
    approvePaymentCardHeader: {
        backgroundColor: "#F8F8F9",
        fontWeight: "700",
        borderTopRightRadius: "5px",
        borderTopLeftRadius: "5px",
    },
    approvePaymentCardHeaderTitle: {
        fontSize: { xs: "14px", md: "16px" },
        fontWeight: "600",
        lineHeight: "16px",
        color: "#0160F1",
    },
    approvePaymentCardContent: {
        backgroundColor: "#FFFFFF",
        borderBottomRightRadius: "5px",
        borderBottomLeftRadius: "5px",
        fontSize: 15,
        marginBottom: -5,
    },
    approvePaymentTypography: {
        fontSize: { xs: "14px", md: "15px" },
    },
    approvePaymentFormControl: {
        maxWidth: 250,
        marginTop: 1,
        marginBottom: 1,
    },
    approvePaymentBox: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        marginTop: { xs: 2, md: 0 },
    },
    approvePaymentfileBox: {
        display: "flex",
        alignItems: "center",
        gap: "2rem",
        flexWrap: "wrap",
    },
    approvePaymentfileUploadBox: {
        flex: "none",
        width: "60%",
        maxWidth: "400px",
        border: "1px dashed #C4C4C4",
        borderRadius: "5px",
        padding: { xs: "0.5rem", md: "1rem" },
    },
    approvePaymentInput: {
        width: "100%",
        fontSize: "14px",
        border: "none",
        outline: "none",
        backgroundColor: "transparent",
    },
    uploadButtonStyle: {
        display: "flex",
        justifyContent: "flex-end",
        marginLeft: 4
    },
    approveRejectButtonContainer: {
        display: "flex",
        justifyContent: "center",
        marginTop: "10px",
        width: "100%",
    },
    approveButtonStyle: {
        color: "white",
        marginRight: "10px",
    },
    paymentReqDetailsCard: {
        backgroundColor: "#EEF2F7",
        padding: "1.3rem",
    }, paymentReqDetailsTable: {

        ".MuiDataGrid-columnHeaderTitle": {
            fontWeight: "bold !important",
        },
        ".MuiDataGrid-cell": {
            fontSize: "0.8rem",
        },
        overflowX: "scroll",

    },
    buttonContainer: {
        marginTop: 1,
        marginBottom: 1,
        display: "flex",
        // justifyContent: "flex-end",
        marginRight: 5,
    },
    processLogCell: {
        alignItems: 'center',
        justifyContent: 'center'
    }



};

export const StyledDatePicker = styled(DatePicker)`
  width: 200px;
  height: 40px;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 8px;
  font-size: 14px;
  color: #333;
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  box-sizing: border-box;
`;

export const boxSX = {
    textDecoration: "none",
    "&:hover": {
        cursor: "pointer",
        textDecoration: "underline",
        color: "darkblue",
    },
};



export const rows = [
    {
        "log_id": 100066,
        "file_name": "uploads/asset_qr_upload/asset_sample_20241016T075021.xlsx",
        "count": 1,
        "create_date": "2024-10-16",
        "status": "Success",
        "tag_file_path": "asset_master/tags/tags_csv/asset_sample_20241016T075021_2024_10_16_07_50_25.csv",
        "id": 1
    },
    {
        "log_id": 100034,
        "file_name": "uploads/asset_qr_upload/asset_sample_20241015T131200.xlsx",
        "count": 1,
        "create_date": "2024-10-15",
        "status": "Success",
        "tag_file_path": "tags/tags_csv/asset_sample_20241015T131200_2024_10_15_13_12_00.csv",
        "id": 2
    },
    {
        "log_id": 100030,
        "file_name": "uploads/asset_qr_upload/asset_sample_20241015T125826.xlsx",
        "count": 1,
        "create_date": "2024-10-15",
        "status": "Success",
        "tag_file_path": "tags/tags_csv/asset_sample_20241015T125826_2024_10_15_12_58_26.csv",
        "id": 3
    },


]

const HoverCell = ({ value }) => {
    return (
        <Tooltip
            title={
                <span style={{ fontSize: "16px" }}>{value}</span>
            }
        >
            <div
                style={{
                    whiteSpace: "none",
                    textAlign: "start",
                    maxWidth: "100%",
                }}
            >{value}</div>
        </Tooltip>
    );
};
export const columns = (downloadProcessLog) => [
    // {
    //     field: "Sr_no",
    //     headerName: "Sr No",
    //     flex: 0.7,
    //     headerAlign: "center",
    //     align: "center",
    //     renderCell: (params) => (
    //         <div style={styles.logIdCell}>{params.id}</div>
    //     ),
    // },
    {
        field: "log_id",
        headerName: "Log Id",
        flex: 0.5,
        headerAlign: "center",
        align: "center",
        renderCell: (params) => (
            <div style={styles.countCell}>{params.value}</div>
        ),
    },
    {
        field: "file_name",
        headerName: "File Name",
        flex: 1,
        renderCell: (params) => <HoverCell value={params.value} />,
    },
    {
        field: "create_date",
        headerName: "Date",
        flex: 0.8,
        headerAlign: "center",
        align: "center",
        renderCell: (params) => (
            <div style={styles.createDateCell}>{params.value}</div>
        ),
    },

    {
        field: "status",
        headerName: "Status",
        flex: 0.5,
        headerAlign: "center",
        align: "center",
        renderCell: (params) => {
            const statusStyles = {
                color: params.value === "Success" ? "green" : "red",
                fontWeight: "600",
            };
            return <div style={statusStyles}>{params.value}</div>;
        },
    },
    {
        field: "affected_count",
        // headerName: "No of records processed",
        headerName: (
            <div style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                No of records processed
            </div>
        ),
        flex: 0.5,
        headerAlign: "center",

        align: "center",
        renderCell: (params) => (
            <div style={styles.countCell}>{params.value}</div>
        ),
    },
    {
        field: "process_log",
        headerName: "Process Logs",
        flex: 0.7,
        headerAlign: "center",
        align: "center",
        renderCell: (params) => (
            <div style={styles.processLogCell}>
                <IconButton
                    aria-label="Download Process Log"
                    onClick={() => downloadProcessLog(params.row.log_id)}
                >
                    <Download color="primary" />
                </IconButton>
            </div>
        ),
    },
];

export const summaryColumns = [
    {
        field: "fusion_supplier",
        headerName: "Fusion Sup Code",
        flex: 1.3,
        headerAlign: "center",
        align: "center",
        renderCell: (params) => (
            <div style={styles.logIdCell}>{params.value}</div>
        ),
    },
    {
        field: "site_name",
        headerName: "Site Name",
        flex: 1.3,
        headerAlign: "center",
        align: "center",
        renderCell: (params) => (
            <div style={styles.logIdCell}>{params.value}</div>
        ),
    },
    {
        field: "total_standard_amt",
        // headerName: "Total Standard Amount",
        headerName: (
            <div style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                Total Invoice Amount (A)
            </div>
        ),
        flex: 1.5,
        headerAlign: "center",
        align: "center",
        renderCell: (params) => (
            <div style={styles.countCell}>
                {/* {params.value} */}
                {params.value
                    ? `₹ ${params.value?.toLocaleString("en-IN")}`
                    : ""}
            </div>
        ),
    }, ,
    {
        field: "total_credit_amt",
        // headerName: "Total Credit Amount",
        headerName: (
            <div style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                Total Credit Amount      (B)
            </div>
        ),
        flex: 1.5,
        headerAlign: "center",
        align: "center",
        renderCell: (params) => (
            <div style={styles.countCell}>
                {/* {params.value} */}
                {params.value
                    ? `₹ ${params.value?.toLocaleString("en-IN")}`
                    : ""}
            </div>
        ),
    }, ,
    {
        field: "total_bank_dr_amt",
        // headerName: "Bank DR Amount",
        headerName: (
            <div style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                Payment Amount           (A-B)
            </div>
        ),
        flex: 1.5,
        headerAlign: "center",
        align: "center",
        renderCell: (params) => (
            <div style={styles.countCell}>
                {/* {params.value} */}
                {params.value
                    ? `₹ ${params.value?.toLocaleString("en-IN")}`
                    : ""}
            </div>
        ),
    },
    {
        field: "error_message",
        headerName: "Error",
        flex: 1.5,
        headerAlign: "center",
        align: "center",
        renderCell: (params) => <HoverCell value={params.value} />,
    }



];


export const employePaymentscolumns = (downloadProcessLog) => [
    {
        field: "sr_no",
        headerName: "Sr no",
        flex: 1.3,
        headerAlign: "center",
        align: "center",
        renderCell: (params) => (
            <div style={styles.logIdCell}>{params.id}</div>
        ),
    },
    {
        field: "file_name",
        headerName: "File Name",
        flex: 1.5,
        wordBreak: "break-word",
        width: 150,
        renderCell: (params) => {
            return <HoverCell value={params.value} />;
        },
    },
    {
        field: 'created_at',
        headerName: 'Date',
        flex: 1,
        headerAlign: 'center',
        align: 'center',
        renderCell: (params) => (
            <div style={{ textAlign: 'center' }}>{params.value}</div>
        ),
    },
    {
        field: 'log_id',
        headerName: 'Log Id',
        flex: 1,
        headerAlign: 'center',
        align: 'center',
        renderCell: (params) => (
            <div style={{ textAlign: 'center' }}>{params.value}</div>
        ),
    },

    {
        field: 'status',
        headerName: 'Status',
        flex: 1,
        headerAlign: 'center',
        align: 'center',
        renderCell: (params) => (
            <div style={{
                textAlign: 'center', color: params.value === 'Success' ? 'green' : 'red',
            }}>{params.value}</div>
        ),
    },
    {
        field: 'no_of_records',
        headerName: (
            <div style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                No of records processed
            </div>
        ),
        flex: 1,
        headerAlign: 'center',
        align: 'center',
    },

    {
        field: "process_log",
        headerName: "Process Log",
        flex: 1,
        headerAlign: 'center',
        align: 'center',
        renderCell: (params) => (
            <div style={styles.processLogCell}>
                <IconButton
                    aria-label="Download Process Log"
                    onClick={() => downloadProcessLog(params.row.log_id)}
                >
                    <Download color="primary" />
                </IconButton>
            </div>
        ),
    }
];



export const paymentTypeOptions = [
    { label: 'Select Payment Type', value: 'PaymentType' },
    { label: 'Salary', value: 'Salary' },
    { label: 'Reimbursement', value: 'Reimbursement' },
    { label: 'FFS Payment', value: 'FFS Payment' },
    { label: 'Temp Advance Hold Salary Release', value: 'Temp Advance Hold Salary Release' },
    { label: 'Bounce Back Salary Release', value: 'Bounce Back Salary Release' },
    { label: 'Temp Advance for Cashier Incentive', value: 'Temp Advance for Cashier Incentive' },
    { label: 'Temp Advance for LM Incentive', value: 'Temp Advance for LM Incentive' },
    { label: 'Temp Advance for MPL Incentive', value: 'Temp Advance for MPL Incentive' },
    { label: 'Salary Advance/Loan', value: 'Salary Advance/Loan' },
    { label: 'House Deposit Advance', value: 'House Deposit Advance' },
    { label: 'Temp Advance', value: 'Temp Advance' },
    { label: 'Temp Advance for PPL Incentive', value: 'Temp Advance for PPL Incentive' },
    { label: 'Any other payment', value: 'Any other payment' },
];

export const employeHistorycolumns = [

    {
        field: "employee_code",
        headerAlign: "center",
        align: "center",
        headerName: (
            <div style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                Employee Code
            </div>
        ),
        flex: 1.5,
        headerAlign: "center",
        align: "center",
        renderCell: (params) => (
            <div style={styles.countCell}>
                {params.value}
            </div>
        ),

    },
    {
        field: "employee_name",
        headerName: (
            <div style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                Employee Name
            </div>
        ),
        flex: 1.5,
        headerAlign: "center",
        align: "center",
        renderCell: (params) => <HoverCell value={params.value} />
    },
    {
        field: "payment_type",
        headerName: (
            <div style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                Payment Type
            </div>
        ),
        flex: 1.5,
        headerAlign: "center",
        align: "center",
        renderCell: (params) => (
            <div style={styles.countCell}>{params.value}</div>
        ),
    }, ,
    {
        field: "payment_date",
        headerName: (
            <div style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                Payment Date
            </div>
        ),
        flex: 1.5,
        headerAlign: "center",
        align: "center",
        renderCell: (params) => (
            <div style={styles.countCell}>
                {params.value}
            </div>
        ),
    },
    {
        field: "batch_id",
        headerName: (
            <div style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                Batch Id
            </div>
        ),
        flex: 1.5,
        headerAlign: "center",
        align: "center",
        renderCell: (params) => (
            <div style={styles.countCell}>
                {params.value}
            </div>
        ),
    },
    {
        field: "utr",
        headerName: (
            <div style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                UTR No.
            </div>
        ),
        flex: 1,
        headerAlign: "center",
        align: "center",
        renderCell: (params) => (
            <div style={styles.countCell}>
                {params.value}
            </div>
        ),
    }
    ,
    {
        field: "status",
        headerName: "Status",
        flex: 1,
        headerAlign: "center",
        align: "center",
        renderCell: (params) => {
            const statusStyles = {

                // fontWeight: "600",
            };
            return <div style={statusStyles}>{params.value}</div>;
        },
    },
];





